// extracted by mini-css-extract-plugin
export default {"mainContainer":"myorder_mainContainer__vJI+j","orderHeading":"myorder_orderHeading__eZ2vF","orderListContainer":"myorder_orderListContainer__KGPjJ"};